import ThemeStyles from "./ThemeStyles";

export default ThemeStyles;
export { ThemeStyles };
